import React from 'react';
import './accountmanagementplatform.scss'

const AccountManagementPlatform = () => {
	const Cards = [
		{
			title: 'Structured Segmentation',
			description: 'Design dynamic account structures based on industry, revenue potential, geography, or custom business rules to align coverage with strategic priorities.'
		},
		{
			title: 'Intelligent Distribution',
			description: 'Automate allocation using capacity-driven logic and rule-based governance to ensure balanced workloads and optimized sales productivity.'
		},
		{
			title: 'Lifecycle Governance',
			description: 'Track renewals, referrals, consumption, and account performance across the complete customer lifecycle.'
		},
		{
			title: 'Executive Visibility',
			description: 'Empower leadership with real-time dashboards, revenue exposure insights, and performance intelligence.'
		}
	]
	return (
		<>
			<div id="endtoendaccountmanagementplatform" className="mainAccountManagementPlatform">
				<div className="subAccountManagementPlatform">
					
					<div className="AccountManagementPlatform">
						<h1 className="mainHeadingPlatfom">End-to-End Account Management Platform</h1>
						<div className="mainParagraphPlatform">
							<p>Sciqus AMS delivers a fully integrated account lifecycle framework — enabling organizations to manage segmentation, allocation, engagement, renewals, expansion, and analytics within a unified enterprise platform.</p>
						</div>
						
						<div className="subAccountManagementPlatformList2">
							<div className="AccountManagementPlatformList2">
								{
									Cards.map ((card, index) => (
										<>
											<div className="AccountManagementPlatformListCard">
												<h2>{card.title}</h2>
												<p>{card.description}</p>
											</div>
										</>
									))
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default AccountManagementPlatform;